export function sanitizeSpeedInsightsUrl(
    eventUrl: string,
    routeId: string | null,
    origin: string,
) {
    if (!routeId?.startsWith("/")) return null;
    const url = new URL(eventUrl, origin);
    return `${url.origin}${routeId}`;
}
